'use client'

import { type FC, type PropsWithChildren } from 'react'
import { Configure } from 'react-instantsearch'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import {
  useAlgoliaUserToken,
  useProxySearchClient,
  useSearchClient,
} from '../../../algolia'
import { useDeviceDetectorContext } from '../../../device-detector'
import {
  PRODUCT_SEARCH_HITS_PER_PAGE,
  ProductSearchVirtualWidgetSearchBox,
  useProductSearchAlgoliaRouting,
  useProductSearchContext,
} from '../../../product-search'

import { StoryblokAlgoliaSearchNotFound } from './StoryblokAlgoliaSearchNotFound'

export const StoryblokAlgoliaSearch: FC<
  PropsWithChildren<{
    enableAdServer?: boolean
    filters?: string
  }>
> = ({ children, enableAdServer = false, filters }) => {
  const {
    productSearchConfig: { baseAlgoliaConfig },
  } = useProductSearchContext()
  const baseSearchClient = useSearchClient()
  const proxySearchClient = useProxySearchClient()
  const { deviceType } = useDeviceDetectorContext()
  const algoliaUserToken = useAlgoliaUserToken()
  const { productsAlgoliaIndex } = baseAlgoliaConfig
  const searchClient = enableAdServer ? proxySearchClient : baseSearchClient

  return (
    <InstantSearchNext
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      indexName={productsAlgoliaIndex}
      routing={useProductSearchAlgoliaRouting()}
      searchClient={searchClient}
    >
      <Configure
        analytics={false}
        analyticsTags={['results', 'externe', 'web', deviceType]}
        clickAnalytics
        enableABTest={false}
        facetingAfterDistinct
        filters={filters}
        getRankingInfo
        hitsPerPage={PRODUCT_SEARCH_HITS_PER_PAGE}
        userToken={algoliaUserToken}
      />
      {children}
      {/*
      The search box is not part of the current page, it's located in the header.
      This virtual widget is used to preserve search parameters in the URL for routing.
      */}
      <ProductSearchVirtualWidgetSearchBox />
      <StoryblokAlgoliaSearchNotFound />
    </InstantSearchNext>
  )
}
